var _defineProperty = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var BufferList = require('bl/BufferList');

var Reader = require('it-reader');

module.exports = function LteReader(source) {
  var _lteReader;

  var reader = Reader(source);
  var overflow;
  var lteReader = (_lteReader = {}, _defineProperty(_lteReader, Symbol.asyncIterator, function () {
    return lteReader;
  }), _defineProperty(_lteReader, "next", function () {
    var _next = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(bytes) {
      var value, _ref, nextValue, done;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!overflow) {
                _context.next = 22;
                break;
              }

              if (!(bytes == null || overflow.length === bytes)) {
                _context.next = 6;
                break;
              }

              value = overflow;
              overflow = null;
              _context.next = 21;
              break;

            case 6:
              if (!(overflow.length > bytes)) {
                _context.next = 11;
                break;
              }

              value = overflow.shallowSlice(0, bytes);
              overflow = overflow.shallowSlice(bytes);
              _context.next = 21;
              break;

            case 11:
              if (!(overflow.length < bytes)) {
                _context.next = 21;
                break;
              }

              _context.next = 14;
              return reader.next(bytes - overflow.length);

            case 14:
              _ref = _context.sent;
              nextValue = _ref.value;
              done = _ref.done;

              if (!done) {
                _context.next = 19;
                break;
              }

              throw Object.assign(new Error("stream ended before ".concat(bytes - overflow.length, " bytes became available")), {
                code: 'ERR_UNDER_READ'
              });

            case 19:
              value = new BufferList([overflow, nextValue]);
              overflow = null;

            case 21:
              return _context.abrupt("return", {
                value: value
              });

            case 22:
              return _context.abrupt("return", reader.next(bytes));

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function next(_x) {
      return _next.apply(this, arguments);
    }

    return next;
  }()), _defineProperty(_lteReader, "nextLte", function () {
    var _nextLte = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(bytes) {
      var _ref2, done, value;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return lteReader.next();

            case 2:
              _ref2 = _context2.sent;
              done = _ref2.done;
              value = _ref2.value;

              if (!done) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt("return", {
                done: done
              });

            case 7:
              if (!(value.length <= bytes)) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", {
                value: value
              });

            case 9:
              value = BufferList.isBufferList(value) ? value : new BufferList(value);

              if (overflow) {
                overflow.append(value.shallowSlice(bytes));
              } else {
                overflow = value.shallowSlice(bytes);
              }

              return _context2.abrupt("return", {
                value: value.shallowSlice(0, bytes)
              });

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function nextLte(_x2) {
      return _nextLte.apply(this, arguments);
    }

    return nextLte;
  }()), _defineProperty(_lteReader, "return", function _return() {
    return reader.return();
  }), _lteReader);
  return lteReader;
};